/**
 * LES DEUX PARTIES D'UN QUESTIONNAIRE DE QUALIFICATION — une seule définition
 * pour le serveur, les écrans et le PDF.
 *
 * QUALIFICATION : posée par le commercial pendant l'appel, relue par le client.
 * ORGANISATION : posée au client seul, dans son questionnaire d'organisation —
 * absente du tunnel du commercial et de la demande de devis.
 *
 * Module partagé front/back : aucune dépendance à Vue ni à Prisma.
 */

export const PARTIE_QUALIFICATION = 'qualification'
export const PARTIE_ORGANISATION = 'organisation'

/** La partie d'une valeur quelconque : « qualification » tant qu'elle n'en dit pas plus. */
export function normaliserPartie(partie) {
  return partie === PARTIE_ORGANISATION ? PARTIE_ORGANISATION : PARTIE_QUALIFICATION
}

/** La partie d'une question (une question enregistrée avant les parties est de qualification). */
export function partieDe(question) {
  return normaliserPartie(question?.partie)
}

export function estOrganisation(question) {
  return partieDe(question) === PARTIE_ORGANISATION
}

/** Les deux parties, dans l'ordre où le client les lit, avec leur libellé de choix. */
export const OPTIONS_PARTIE = [
  { value: PARTIE_QUALIFICATION, label: 'Qualification — posée par le commercial pendant l’appel, relue par le client' },
  { value: PARTIE_ORGANISATION, label: 'Organisation — posée au client seul, dans son questionnaire d’organisation' },
]
